module.exports = __webpack_public_path__ + "img/bar-code.7305a5b5.svg";